var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "draggable",
            {
              staticStyle: { display: "flex", "flex-wrap": "wrap" },
              on: { start: _vm.start, end: _vm.end },
              model: {
                value: _vm.fileList,
                callback: function ($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList",
              },
            },
            [
              _vm._l(_vm.fileList, function (item, index) {
                return _c(
                  "div",
                  { key: item + index, staticClass: "itemI" },
                  [
                    _c("el-image", {
                      staticStyle: {
                        width: "108px",
                        height: "108px",
                        "border-radius": "6px",
                      },
                      attrs: { src: item.url },
                      on: {
                        click: function ($event) {
                          return _vm.handlePictureCardPreview(item)
                        },
                      },
                    }),
                    index == 0 && _vm.isCustomer == 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#2d46ee",
                              position: "absolute",
                              top: "100px",
                              left: "10px",
                            },
                          },
                          [_vm._v("（商品主图）")]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(item, index)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-close",
                          staticStyle: { color: "#2d46ee" },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticStyle: { "margin-bottom": "7px" },
                  attrs: {
                    limit: _vm.limit,
                    action: "",
                    accept: "image/*",
                    "http-request": _vm.uploadFile,
                    "list-type": "picture-card",
                    "auto-upload": true,
                    "file-list": _vm.fileList,
                    "on-preview": _vm.handlePictureCardPreview,
                    "on-exceed": _vm.handleExceed,
                    "show-file-list": false,
                    multiple: "",
                  },
                },
                [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
              ),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }